module.exports = __webpack_public_path__ + "static/media/heartFull.ba37ad71.svg";